module.exports = __webpack_public_path__ + "static/media/paperplane.bf6226d8.gif";